import { Icon } from '@iconify/react';

import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import Bar from '../../../dashboard/Bar.jsx';
import Line from '../../../dashboard/Line.jsx';

// import SalaryByOrg from './SalaryByOrg.jsx';
import { Card, CardBody, CardExpandToggler } from '../../../../components/card/card.jsx';
import Loading from '../../../../components/Shared/Loader/Loading.js';
import { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Pie from '../../../dashboard/Pie.jsx';
import Breadcrumb from '../../../../components/Shared/Breadcrumb.js';

const ARDashboard = () => {
  const { t } = useTranslation();

  const [barChartData, setBarChartData] = useState({
    title: 'إجمالي المستحقات لكل عميل',
    categories: ['عميل 1', 'عميل 2', 'عميل 3', 'عميل 4'],

    series: [
      {
        name: 'المستحقات',
        data: [5000, 8000, 12000, 3000], // المستحقات لكل عميل
      },
    ],
  });

  const [comboChartData, setComboChartData] = useState({
    title: 'المدفوعات والمستحقات المتأخرة',
    categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],

    series: [
      {
        name: 'المدفوعات',
        type: 'column',
        data: [2000, 3000, 5000, 4000, 6000, 7000], // المدفوعات الشهرية
      },
      {
        name: 'المستحقات المتأخرة',
        type: 'line',
        data: [1000, 2000, 1500, 1800, 2500, 3000], // المستحقات المتأخرة
      },
    ],
  });

  const [pieChartData, setPieChartData] = useState({
    title: 'توزيع المستحقات حسب الفئة',
    labels: ['مدفوعات', 'مبالغ متأخرة', 'مستحقات أخرى'],
   
    series: [60, 30, 10], // نسب المستحقات
  });

  const [lineChartData, setLineChartData] = useState({
    title: 'تغير المستحقات بمرور الوقت',
    categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],

    series: [
      {
        name: 'المستحقات',
        data: [5000, 7000, 10000, 12000, 13000, 15000], // المستحقات الشهرية
      },
    ],
  });

  const [pieChartData2, setPieChartData2] = useState({
    title: 'توزيع المستحقات حسب الحالة',
    labels: ['مدفوعة', 'متأخرة', 'غير مدفوعة'],
  
    series: [50, 30, 20], // توزيع المستحقات حسب الحالة
  });

  return (
    <div>
            <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: null,
          },
        ]}
      />
      <Loading loading={false} error={null}>
        <>
          <div className="row g-4">
            <div className="col-12 col-md-6 col-lg-6">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{barChartData.title}</span>
                    <CardExpandToggler />
                  </div>

                  <Bar
                    categories={barChartData.categories}
                    series={barChartData.series}
                    height={400}
                  />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-6">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{comboChartData.title}</span>
                    <CardExpandToggler />
                  </div>

                  <Line categories={comboChartData.categories} series={comboChartData.series} />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{pieChartData.title}</span>
                    <CardExpandToggler />
                  </div>

                  <Pie labels={pieChartData.labels} series={pieChartData.series} height={500} />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{lineChartData.title}</span>
                    <CardExpandToggler />
                  </div>

                  <Line categories={lineChartData.categories} series={lineChartData.series} />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{pieChartData2.title}</span>
                    <CardExpandToggler />
                  </div>

                  <Pie labels={pieChartData2.labels} series={pieChartData2.series} height={500} />
                </CardBody>
              </Card>
            </div>
          </div>
        </>
      </Loading>
    </div>
  );
};

export default ARDashboard;
